import { useTranslation } from 'react-i18next';
import styles from './PrivateSharedSelectors.module.scss';
import { Form } from 'react-bootstrap';
import { useModal } from '../providers/ModalProvider';
import { keys } from '../utilities/translator/translation_keys';
import { Text } from './typography';
import TextWithIcon from './typography/TextWithIcon';
import { useState } from 'react';

export default function PrivateSharedSelectors({
  onPrivateSubmit,
  isPrivate,
  readOnly,
}) {
  const { t } = useTranslation();
  const { openConfirmationModal } = useModal();
  const [showPrivateText, setShowPrivateText] = useState(false);
  return (
    <div className={styles.container}>
      <div className={styles.flexRow}>
        <Form.Check
          disabled={readOnly}
          checked={isPrivate}
          onChange={() => {
            const description = `Are you sure you want to make this document ${
              isPrivate ? 'public' : 'private'
            }? This will ${
              !isPrivate
                ? 'allow only admins and participants '
                : 'allow all users '
            }to view this incident.`;
            openConfirmationModal({
              title: 'Change Document Visibility',
              description,
              variant: 'danger',
              onSubmit: (e) => {
                onPrivateSubmit(!isPrivate);
              },
            });
          }}
        />
        <TextWithIcon
          weight="semiBold"
          iconProps={{ fontSize: '1rem' }}
          icon="info"
          noMargin
          onClick={() => setShowPrivateText(!showPrivateText)}
        >
          {t(keys.action_items.PRIVATE_TITLE)}
        </TextWithIcon>
      </div>
      {!!showPrivateText && (
        <Text size="sm" color="secondary" className={styles.text} noMargin>
          {t(keys.action_items.PRIVATE_DEFINITION)}
        </Text>
      )}
    </div>
  );
}
